import { useEffect, useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { useSetRecoilState } from 'recoil';

import { useFetchSearchFieldType, useFetchSearchItemType } from 'lib/swr/hooks';

import { useCurrentWorkspace } from './hooks/workspaces/useCurrentWorkspace';
import { ITEM_TYPE_DISPLAY_MODULE } from './global';
import { fieldTypeStore, itemTypeStore, workspaceIdStore } from './store';

const initialFlag = { _initial: true };

/*
 * 确保在 <RecoilRoot/> 下的组件使用
 * */
export const useInitialRecoilState = (): void => {
  const workspace = useCurrentWorkspace();
  const workspaceId = useMemo(() => workspace?.objectId, [workspace]);

  const { data: itemTypeData } = useFetchSearchItemType({
    config: { fallbackData: [] },
    params: {
      propertyNames: ['objectId', 'icon', 'key', 'name', 'displayConditions'],
      context: {
        skipItemTypeQueryFilter: true,
        displayModule: ITEM_TYPE_DISPLAY_MODULE.View,
      },
    },
  });

  const { data: fieldTypeData } = useFetchSearchFieldType({
    params: {
      excludeProperties: ['createdAt', 'updatedAt', 'description', 'createdBy', 'updatedBy', 'disabled', 'property'],
    },
    config: { fallbackData: [] },
  });

  const setItemTypeState = useSetRecoilState(itemTypeStore);
  const setFieldTypeState = useSetRecoilState(fieldTypeStore);
  const setWorkspaceIdState = useSetRecoilState(workspaceIdStore);

  useEffect(() => {
    setWorkspaceIdState(workspaceId);
  }, [workspaceId, setWorkspaceIdState]);

  useEffect(() => {
    setItemTypeState(prevState => {
      return {
        ...prevState,
        ...keyBy(itemTypeData || [], 'objectId'),
        ...initialFlag,
      };
    });
  }, [setItemTypeState, itemTypeData]);

  useEffect(() => {
    setFieldTypeState(prevState => {
      return {
        ...prevState,
        ...keyBy(fieldTypeData || [], 'objectId'),
        // ...initialFlag, // 会对新建字段时默认选中第一项干扰，暂时去掉
      };
    });
  }, [setFieldTypeState, fieldTypeData]);
};
